/*
 * Copyright 2026 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { hasTables, isTableEntity } from './isTableEntity';

const dataTableCard = EntityCardBlueprint.make({
  name: 'data-table',
  params: {
    type: 'content',
    filter: isTableEntity,
    loader: () => import('./DataTableCard').then(m => <m.DataTableCard />),
  },
});

const tablesBySchemaCard = EntityCardBlueprint.make({
  name: 'tables-by-schema',
  params: {
    type: 'content',
    filter: hasTables,
    loader: () =>
      import('./TablesBySchemaCard').then(m => <m.TablesBySchemaCard />),
  },
});

export const dataTableModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [dataTableCard, tablesBySchemaCard],
});
